import * as React from "react";
import { Layout } from "../components";
import About from "../components/sections/about";
import Background from "../components/sections/background";
import Contact from "../components/sections/contact";
import Hero from "../components/sections/hero";
import Projects from "../components/sections/projects";

const headerStyles = [
  "color: white",
  "background: black",
  "font-size: 30px",
  "text-shadow: 4px 4px 0 hsla(0,0%,20%,1)",
  "padding: 8px",
  "font-family: Poppins , sans-serif",
  "font-weight:500",
].join(";");

const descriptionStyles = [
  "color: #FF9933",
  "background: black",
  "font-size: 12px",
  "padding: 8px",
  "font-family: Inconsolata , sans-serif",
  "font-weight:500",
  "letter-spacing:2px",
].join(";");

const IndexPage = () => {
  console.log("%czijian.me", headerStyles);
  console.log("%cFollow me on my github account 🥰😀👋", descriptionStyles);

  return (
    <Layout>
      <main>
        <Hero />
        <About />
        <Background />
        <Projects />
        <Contact />
      </main>
    </Layout>
  );
};

export default IndexPage;
